<template>
    <div class="MT45Page">
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <page-navigate></page-navigate>
         <div class="MT4Header flex box-border">
      <div class="MT4HeaderMain">
        <h1 class="MT4Title super_large-80_bold md-title-32_bold">
          MetaTrader 4
        </h1>
        <h2 class="MT4Desc subtitle-20_regular md-body-14_regular">
          MT4是最受欢迎的交易平台之一，因技术先进，易于使用，安全系数高，受到全球交易者的亲睐
        </h2>
        <a :href="signupUrl" class="jumpA">
          <div class="MT4Btn primary-default_large cursor-pointer">
            开始交易
            <span class="iconfont icon-right"></span>
          </div>
        </a>
      </div>
      <img
        src="@/assets/image/mt/mt4Container1.png"
        alt=""
        class="MT4HeaderModel"
      />
    </div>
    <div class="MT4Download">
      <div class="contentBox">
       
        <h2 class=" MT4DownloadTitle title-48_bold md-title-24_bold MT4DownloadTitle text-center scroll-fade-up">
          MetaTrader 4 下载
        </h2>
        <h3 class="MT4DownloadDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up">提供强大的交易和分析功能，支持1700多个自动交易和2100多种技术指标</h3>

        <!-- <h3
          class="subtitle-20_regular md-footnote-regular_12 MT4DownloadDesc text-center scroll-fade-up"
        >
          选择您偏好的设备，下载适用的 MT4
          平台程序，立即体验高速顺畅，且符合个人风格的交易
        </h3> -->
        <div class="MT4DownloadList flex justify-center scroll-fade-up">
           <div class="MT4DownloadListCard">
            <div class="title-24_bold subtitle-20_medium MT5DownloadCardTitle text-center">MT4 移动端</div>
            <div class="MT4DownloadCardDesc body-14_regular  md-footnote-regular_12">
              随时随地进行交易，掌握市场动态，轻松管理账户
            </div>
          <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/metatrader4.apk" class="MT4ATag" target="_blank">
            <!-- <img src="@/assets/image/mt/QRCodeLogo.png" alt="" class="qrCode pc"> -->
            <div class="MT4DownloadItem">
              <img src="@/assets/image/mt/android.png" alt="">
              <div class="subtitle-20_medium">下载安卓版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          <a href="https://apps.apple.com/cn/app/metatrader-4/id496212596 " class="MT4ATag" target="_blank">
            <!-- <img src="@/assets/image/mt/QRCodeLogo.png" alt="" class="qrCode pc"> -->
            <div class="MT4DownloadItem">
              <img src="@/assets/image/mt/ios.svg" alt="">
              <div class="subtitle-20_medium">下载苹果版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
         
          </div>
          <div class="MT4DownloadListCard">
            <div class="title-24_bold subtitle-20_medium MT5DownloadCardTitle text-center">MT4 电脑端</div>
 <div class="MT4DownloadCardDesc body-14_regular  md-footnote-regular_12">
              全面的交易工具和高级图表分析，满足专业交易者的高阶需求
            </div>
          <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/ebcfinancialgroupky4setup.exe" class="MT4ATag" target="_blank">
            <div class="MT4DownloadItem">
              <img src="@/assets/image/mt/windows.svg" alt="">
              <div class="subtitle-20_medium">下载Windows版</div>
            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/MetaTrader4.pkg.zip" class="MT4ATag" target="_blank">
            <div class="MT4DownloadItem">
              <img src="@/assets/image/mt/macos.svg" alt="">
              <div class="subtitle-20_medium">下载MacOS版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          </div>
          <div class="MT4DownloadListCard">
            <div class="title-24_bold subtitle-20_medium MT5DownloadCardTitle text-center">MT4 网页版</div>
<div class="MT4DownloadCardDesc body-14_regular md-footnote-regular_12 zh">
              无需下载，极速访问全球市场，轻松实现全方位的在线交易管理
            </div>
          <a href="/MetaTraderWeb.html?lang=cn" class="MT4ATag" target="_blank">
            <div class="MT4DownloadItem">
              <img src="@/assets/image/mt/pc.png" alt="">
              <div class="subtitle-20_medium">打开网页版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          </div>
         

        </div>
      </div>
    </div>
    <div class="MT45Diff ">
      <div class="contentBox">
      <h2 class="title-48_bold md-title-24_bold text-center scroll-fade-up">MT4 与 MT5 的区别</h2>
      <h3 class="MT45DiffDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up">MT4 和 MT5 均由 MetaQuotes 开发，但 MT5 并非 MT4 的简单升级版，两者在功能和适用范围上存在显著差异</h3>
      <div class="MT45DiffTable scroll-fade-up">
        <div class="MT45Thead">
          <div class="body-16_medium md-body-14_medium">账户平台</div>
          <div class="subtitle-18_medium md-body-14_medium">MT4</div>
          <div class="subtitle-18_medium md-body-14_medium">MT5</div>
        </div>
        <div class="MT45Tbody">
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">发布时间</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">2005 <span class="body-16_medium  md-footnote-medium_12">年</span> </div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">2010 <span class="body-16_medium  md-footnote-medium_12">年</span> </div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">交易市场</div>
            <div class="MT45Td body-16_medium md-footnote-medium_12">主要是外汇</div>
             <div class="MT45Td body-16_medium md-footnote-medium_12">包括股票、期货、外汇等</div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">挂单类型</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">4 <span class="body-16_medium  md-footnote-medium_12">种</span></div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">6 <span class="body-16_medium  md-footnote-medium_12">种</span></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">时间框架</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">9 <span class="body-16_medium md-footnote-medium_12">种</span></div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">21 <span class="body-16_medium md-footnote-medium_12">种</span></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">技术指标</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">30 <span class="body-16_medium md-footnote-medium_12">个</span></div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">38 <span class="body-16_medium md-footnote-medium_12">个</span></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">市场深度</div>
            <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableF.svg" alt=""></div>
             <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableY.svg" alt=""></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">财经日历</div>
            <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableF.svg" alt=""></div>
             <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableY.svg" alt=""></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">操作界面</div>
            <div class="MT45Td body-16_medium md-footnote-medium_12">更直观简单</div>
             <div class="MT45Td body-16_medium md-footnote-medium_12">更加现代化灵活</div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <open-account-mt45 pageType="MT4"></open-account-mt45>
     <section class="container4 commonQuestion">
        <div class="contentBox">
        <h2 class="scroll-fade-up">MT4常见问题</h2>
        <div class="QA-list">
          <div class="QA-item">
            <div class="QA-title">1、MetaTrader4（MT4）是什么？为什么它在交易者中备受欢迎？ </div>
            <div class="QA-content">
              <p class="QA-li">
                MetaTrader4（MT4）是全球最受信赖的交易平台，以速度、稳定性和灵活性为核心优势。基于EBC的深度流动性和极具竞争力的定价，它提供快速执行、精准的图表分析和无缝的订单管理功能，因此成为全球外汇和差价合约（CFD）交易者的首选平台。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">2、MT4交易平台有哪些特点，使其成为外汇和差价合约交易的理想选择？</div>
            <div class="QA-content">
              <p class="QA-li">
                MT4具备专业交易者所需的一切功能：高级图表工具、一键交易执行、多种订单类型以及支持自动化策略。通过EBC，交易者只需一个易用平台，实现与全球市场的可靠连接，并获得透明定价及机构级交易性能。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">3、MT4适合初学者吗？</div>
            <div class="QA-content">
              <p class="QA-li">
                是的。MT4界面直观，操作简单，是新手入门的理想选择。其简洁的布局、便捷的订单功能和模拟账户支持，让新手交易者能够安全练习。EBC提供稳定的交易环境和实用指导，帮助客户自信提升交易技能。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">4、我可以通过MT4平台交易多种资产类别，如外汇、商品和指数吗？</div>
            <div class="QA-content">
              <p class="QA-li">
                当然可以。通过EBC的MT4交易平台，仅需一个账户，获得全球市场准入：货币对、全球指数、主流商品、股票差价合约、ETF等。这种多资产灵活性，帮助交易者多元化投资组合，捕捉不同市场条件下的机会。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">5、MT4需要付费使用吗？</div>
            <div class="QA-content">
              <p class="QA-li">
                下载和使用MetaTrader4完全免费，无平台费或订阅费。只需在EBC开设账户并安全存入资金，即可开始交易。唯一成本，是每笔交易中透明展示的点差或佣金。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">6、MT4平台的交易安全性如何？</div>
            <div class="QA-content">
              <p class="QA-li">
                通过EBC的MT4交易时，数据受高级加密和安全登录协议保护。EBC遵循严格的全球监管标准，客户资金存放在顶级银行的独立账户中。这种多层次保护确保交易始终安全可靠。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">7、什么样的系统要求可以流畅运行MetaTrader 4？</div>
            <div class="QA-content">
              <p class="QA-li">
                MT4可在大多数现代系统上流畅运行，如Windows 7及以上版本、Mac（通过模拟器）以及最新Android和iOS设备。稳定网络连接和至少512MB内存可保障流畅操作。建议直接从EBC官网下载最新验证版本。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">8、MT4是否支持自动化交易和专家顾问（EAs）？</div>
            <div class="QA-content">
              <p class="QA-li">
                支持。MT4通过专家顾问（EAs）实现全自动化交易。交易者可构建、导入和测试算法以自动执行策略。结合EBC的低延迟执行和可靠基础设施，可实现全天候精准交易。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">9、我可以自定义MT4平台的图表和指标吗？</div>
            <div class="QA-content">
              <p class="QA-li">
                可以。MT4支持完全自定义：调整图表颜色、添加或修改指标、创建个性化模板等。这种灵活性帮助交易者根据自身交易风格定制工作空间，优化市场分析体验。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">10、我能从MT4出金吗？</div>
            <div class="QA-content">
              <p class="QA-li">
                MT4直接无法处理出金。通过EBC客户端，您可安全申请入金和出金。处理完成后，MT4账户余额将自动更新。EBC受监管的处理流程，确保每笔交易快速、透明且符合国际标准。
              </p>
            </div>
          </div>
        </div>
        </div>
      </section>
        <page-footer></page-footer>
    </div>
</template>
<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from 'vuex';

export default {
    mixins: [fadeAnimate],
    data() {
        return {

        }
    },
    mounted(){
      
          document.querySelectorAll('.MT4DownloadItem').forEach((i,index)=>{
        if(index == 4){
          i.insertAdjacentHTML('beforeend',`
          <span class="arrowBtn">
<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5783_6509)">
<path d="M23.6666 19.3333C23.6666 19.8855 23.2189 20.3333 22.6666 20.3333C22.1143 20.3333 21.6666 19.8855 21.6666 19.3333V11.7473L7.37361 26.0403C6.98309 26.4308 6.35007 26.4308 5.95955 26.0403C5.56903 25.6498 5.56903 25.0167 5.95955 24.6262L20.2525 10.3333H12.6666C12.1143 10.3333 11.6666 9.88554 11.6666 9.33325C11.6666 8.78097 12.1143 8.33325 12.6666 8.33325H22.6666C23.2189 8.33325 23.6666 8.78097 23.6666 9.33325V19.3333Z" fill="black" fill-opacity="0.64"/>
</g>
<defs>
<clipPath id="clip0_5783_6509">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
</span>
`)
return
        }
        i.insertAdjacentHTML('beforeend',`
<span class="Btn">
  <svg
    class="svgIcon"
    viewBox="0 0 384 512"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ></path>
  </svg>
  <span class="icon2"></span>
</span>
`)
      })
    },
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>
<style scoped>
  .contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}
.MT4Header {
  padding-top: 144rem;
  background-color: var(--ebc-neutral-bg_c);
}

.MT4Header {
  height: 560rem;
  padding-left: calc(50vw - 600rem);
  gap: 62rem;
}
.MT4HeaderMain {
  flex: 0 0 588rem;
  margin-top: 16rem;
}
.MT4Title {
}
.MT4Btn {
  width: fit-content;
  min-width: 180rem;
  gap: 4rem;
}
.jumpA {
  display: block;
  width: fit-content;
}
.MT4Desc {
  color: var(--ebc-text-secondary);
  margin: 24rem 0 64rem;
}

.MT4HeaderModel {
  width: 550rem;
  height: 335rem;
}
.MT4DownloadDesc{
  margin: 16rem 0 60rem;
}
@media screen and (max-width: 996px) {
  .MT4DownloadDesc{
  margin-bottom: 80rem;
}
  .MT4Header {
    flex-direction: column;
    height: auto;
    gap: 134rem;
    padding: 134rem 32rem 80rem;
    text-align: center;
  }
  .MT4HeaderMain {
    order: 2;
    flex: 1;
  }
  .MT4HeaderModel {
    width: 100%;
    height: 416rem;
  }
  .jumpA {
    width: 100%;
  }
  .MT4Btn {
    width: 100%;
    height: 96rem;
    gap: 8rem;
  }
}

.MT4Download {
  padding: 80rem 0 0;
  background: var(--ebc-basecolor-white-100);
}

.MT4DownloadCardList {
  align-items: stretch;
  gap: 24rem;
  margin-bottom: 120rem;
}
.MT4DownloadCard {
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  padding: 32rem 24rem;
  flex: 1;
}

.MT4DownloadCard img {
  width: 32rem;
  margin-bottom: 16rem;
}

.MT4DownloadTitle{
  margin-bottom: 0rem;
}

.MT4DownloadDesc {
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.MT4DownloadList {
 gap: 24rem;
  margin-inline: auto;
  align-items: stretch;
}
.MT4DownloadListCard{
  padding:24rem;
  flex:1;
  border-radius: var(--ebc-corner-radius-rc16);
  border: 1px solid  rgba(0, 0, 0, 0.12);
}
.MT4DownloadListCard a{
  display: block;
}
.MT4DownloadListCard a:nth-child(2){
  margin-top: 24rem;
}
.MT4DownloadListCard a:nth-child(n+3){
  margin-top: 16rem;
}
.MT4ATag {
 border-radius: var(--ebc-corner-radius-rc16);
  flex: 0 0 336em;
  height: 64rem;
  position: relative;
  overflow: hidden;
}


.MT4ATag .MT4DownloadItem {
  padding: 16rem 24rem;
  height: 64rem;
  display: flex;
  align-items: center;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_b);
}

.MT4ATag .hoverDownloadItem{
  display: none!important;
  position: absolute;
  inset: 0;
  z-index:-1;
  width: 100%;
  height: 100%;
  padding:40rem 0 24rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  color: #000;
}
.MT4ATag .hoverDownloadItem div{
  text-align: center;
}
@media screen and (min-width:996px) {
.MT4ATag .MT4DownloadItem div{
  font-size: 16rem;
  font-weight: 400;
}
/* .MT4ATag:hover .MT4DownloadItem{
  background: ;
} */

.MT4ATag:hover .MT4DownloadItem div{
  color: var(--ebc-basecolor-active-500);
  font-weight: 500;
}
/* .MT4ATag:hover .MT4DownloadItem img{
  filter: brightness(0) invert(1);
} */


}

.MT4ATag .hoverDownloadItem img{
  width: 56rem;
  height: 56rem;
}
.MT4ATag img {
  /* flex: 1; */
  height: 32rem;
  margin-right: 16rem;
}
.MT4ATag .MT4DownloadItem div {
  color: #000;
  margin-right: auto;
  line-height: normal;
}
@media screen and (max-width: 996px) {
.MT4ATag .hoverDownloadItem{
  display: none;
}
.MT4ATag .MT4DownloadItem {
  justify-content: flex-end;
}
  .MT4Download {
    padding: 80rem 32rem 0rem;
  }
  .MT4DownloadCardList {
    flex-direction: column;
    gap: 32rem;
    margin-bottom: 160rem;
  }
  .MT4DownloadCard {
    padding: 32rem;
  }
  .MT4DownloadCard img {
    width: 64rem;
    margin-bottom: 32rem;
  }
  .MT4DownloadDesc {
    margin: 16rem 0 80rem;
  }
  .MT4DownloadList {
    gap: 48rem;
    flex-direction: column;
  }
   .MT4DownloadListCard{
    padding:16rem;
    border: 0;
  }
  .MT4DownloadListCard a:nth-child(2){
  margin-top: 48rem;
}
.MT4DownloadListCard a:nth-child(n+3){
  margin-top: 32rem;
}
  .MT4ATag {
    height: 112rem;
    border-radius: var(--ebc-corner-radius-rc16);
  }
  .MT4ATag .MT4DownloadItem {
    padding: 32rem 48rem;
    height: 112rem;
  }
  .MT4ATag:nth-child(3) {
    order: 2;
  }
  .MT4ATag:nth-child(1),
  .MT4ATag:nth-child(2) {
    order: 3;
  }
  .MT4ATag img {
    height: 48rem;
    margin-right: 32rem;
  }

  .MT4ATag .MT4DownloadItem div {
    /* margin-top: 32rem; */
    font-size: 28rem;
    font-weight: 400;
    min-height: 48rem;
  }
}

.MT45Diff {
  padding: 120rem 0;
  background: #fff;
}

.MT45DiffDesc {
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.MT45DiffTable {
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: var(--ebc-corner-radius-rc16);
}
.MT45Thead {
  display: flex;
  align-items: center;
  background: var(--ebc-neutral-bg_c);
  padding: 25rem 40rem;
}
.MT45Tbody {
  padding-inline: 40rem;
}
.MT45Thead div:first-child {
  flex: 1;
  text-align: left;
}
.MT45Tr div:first-child {
  color: var(--ebc-text-tertiary);
  text-align: left;
  flex: 1;
}
.MT45Thead div,
.MT45Tr div {
  text-align: center;
}
.MT45Tr {
  display: flex;
  align-items: center;
}
.MT45Thead div:nth-child(2),
.MT45Tr div:nth-child(2) {
  flex: 3;
}

.MT45Thead div:nth-child(3),
.MT45Tr div:nth-child(3) {
  flex: 1.8;
}
.MT45Tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 16rem 0;
}
.MT45Tr .MT45Td {
  min-height: 36rem;
  line-height: 36rem;
}

.MT45Tr:last-child {
  border: 0;
}
@media screen and (min-width: 996px) {
  .MT45Tbody img{
    transform: translateY(4rem);
  }
}
.MT4DownloadCardDesc{
  margin:8rem 0 32rem;
  min-height: 44rem;
  color: var(--ebc-text-secondary);
  text-align: center;
}
@media screen and (max-width: 996px) {
   .MT4DownloadItem svg{
    width: 24px;
    height: 24px;
  }
  .MT4DownloadCardDesc{
margin: 16rem 0 32rem;
text-align: center;
  white-space: nowrap;

}
  .MT45Diff {
    padding: 160rem 32rem;
  }
  .MT45DiffDesc {
    margin: 16rem 0 80rem;
  }
  .MT45Tr div,
  .MT45Thead div {
    min-height: 112rem;
    padding: 16rem 24rem;
  }
  .MT45Thead div:nth-child(2),
  .MT45Tr div:nth-child(2),
  .MT45Thead div:nth-child(3),
  .MT45Tr div:nth-child(3) {
    flex: 1.6;
  }
  .MT45Thead,
  .MT45Tbody {
    padding: 0;
  }
  .MT45Thead div,
  .MT45Tr div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4rem;
  }
   .MT45Thead div:nth-child(1),
  .MT45Tr div:nth-child(1){
    justify-content: flex-start;
  }
   .ar .MT45Thead div:nth-child(1),
  .ar .MT45Tr div:nth-child(1){
    justify-content: flex-end;
    text-align: right;
  }
  .MT45Td span {
    align-self: flex-end;
    line-height: 30rem;
  }
}



</style>
<style lang="scss">
@import url("../assets/css/commonQuestion.scss");

.MT4ATag:hover .MT4DownloadItem svg path{
  fill: #fff;
  fill-opacity: 1;
}

.MT45Page {
  .Btn {
  width: 32rem;
  height: 32rem;
  border: none;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition-duration: 0.3s;
}

.svgIcon {
  fill: var(--ebc-text-secondary);
  width: 10px;
  height: 18px;
}

.icon2 {
  width: 16px;
  height: 4px;
  border-bottom: 2px solid var(--ebc-text-secondary);
  border-left: 2px solid var(--ebc-text-secondary);
  border-right: 2px solid var(--ebc-text-secondary);
  margin-top: -4px;
}




.attchDownload:hover .icon2,
.MT4DownloadItem:hover .icon2 {
  border-bottom: 2px solid var(--ebc-basecolor-active-500);
  border-left: 2px solid var(--ebc-basecolor-active-500);
  border-right: 2px solid var(--ebc-basecolor-active-500);
}
.attchDownload:hover .svgIcon,
.MT4DownloadItem:hover .svgIcon {
  fill: var(--ebc-basecolor-active-500);
  animation: slide-in-top 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes slide-in-leftBottom {
  0% {
    transform: translate(-50%,50%);
    opacity: 0;
  }

  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
.MT4ATag .MT4DownloadItem .arrowBtn{
  width: 25rem;
  height: 25rem;
  display: block;
}

.MT4ATag .MT4DownloadItem:hover .arrowBtn svg path{
  fill: var(--ebc-basecolor-active-500);
}
.MT4ATag .MT4DownloadItem:hover .arrowBtn svg {
  animation: slide-in-leftBottom 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.MT4ATag .MT4DownloadItem:hover .arrowBtn svg:nth-child(2){
  transition: transform 0.3s ease-in-out 0.1s;
  transform: translate(0);
}
.MT4ATag .MT4DownloadItem:hover div{
  color: var(--ebc-basecolor-active-500);
}
.MT4DownloadListCard:first-child .MT4ATag:first-child .MT4DownloadItem:hover div{
  color: var(--ebc-text-primary);
}
.MT4DownloadItem:hover svg path{
  fill: var(--ebc-basecolor-active-500);
}
.MT4DownloadListCard:first-child .downArrow{
  width: 32rem;
  height: 12rem;
}

.attchDownloadList .attchDownload:hover div{
  color: var(--ebc-basecolor-active-500);
}
}
@media (max-width:996px){

}
</style>
